/** Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */
// import "./src/styles/tailwind.base.css"
import "./src/styles/application.css"
// import "./src/styles/tailwind.after.css"

import "@reach/dialog/styles.css"
import "swiper/css"
import "swiper/css/pagination"
import "swiper/css/navigation"
import "swiper/css/zoom"

import React from "react"
import { navigate } from "gatsby"
import { ClerkProvider } from "@clerk/react"
import { ContextProvider } from "./src/context"

// Route Clerk's step navigation (sign-up → password → OTP, SSO callbacks, …)
// through Gatsby's client-side router instead of hard browser navigations.
// Without these, path routing triggers a full page reload on every step,
// which shows up as a flash/blank between screens.
export const wrapRootElement = ({ element }) => {
  return (
    <ClerkProvider
      publishableKey={process.env.GATSBY_CLERK_PUBLISHABLE_KEY}
      routerPush={to => navigate(to)}
      routerReplace={to => navigate(to, { replace: true })}
    >
      <ContextProvider>{element}</ContextProvider>
    </ClerkProvider>
  )
}
